import {
  AddCalendarEventInput,
  CalendarEvent,
  EditCalendarEventInput,
  GetCalendarEventsInput,
} from '@app/core/interfaces';
import { createAction, props } from '@ngrx/store';

export const getCalendarEventsRequest = createAction(
  '[Calendar Events API] Load All Calendar Events',
  props<GetCalendarEventsInput>()
);

export const getCalendarEventsSuccess = createAction(
  '[Calendar Events API] Load All Calendar Events Success',
  props<{ calendarEvents: CalendarEvent[] }>()
);

export const getCalendarEventsFailed = createAction(
  '[Calendar Events API] Load All Calendar Events Failure',
  props<{ error: string }>()
);

export const addCalendarEventRequest = createAction(
  '[Calendar Event Form] Add Calendar Event Request',
  props<{ eventData: AddCalendarEventInput }>()
);

export const addCalendarEventSuccess = createAction(
  '[Calendar Events API] Add Calendar Event Success',
  props<{ calendarEvent: CalendarEvent }>()
);
export const addCalendarEventFailed = createAction(
  '[Calendar Events API] Add Calendar Event Failure',
  props<{ error: string }>()
);

export const updateCalendarEventRequest = createAction(
  '[Calendar Event Form] Update Calendar Event Request',
  props<{ eventData: EditCalendarEventInput }>()
);
export const updateCalendarEventSuccess = createAction(
  '[Calendar Events API] Update Calendar Event Success',
  props<{ calendarEvent: CalendarEvent }>()
);
export const updateCalendarEventFailed = createAction(
  '[Calendar Events API] Update Calendar Event Failure',
  props<{ error: string }>()
);

export const removeCalendarEventRequest = createAction(
  '[Calendar Event Details] Remove Calendar Event Request',
  props<{ id: number }>()
);
export const removeCalendarEventSuccess = createAction(
  '[Calendar Events API] Remove Calendar Event Success',
  props<{ id: number }>()
);
export const removeCalendarEventFailed = createAction(
  '[Calendar Events API] Remove Calendar Event Failure',
  props<{ error: string }>()
);
